module.exports = __webpack_public_path__ + "img/indexDbg.0369da61.png";